import React from "react";
import PropTypes from "prop-types";

const defaultStyle = {
  background: "none",
  border: "none",
  padding: 0,
  // color: "#000",
  textDecoration: "none",
  cursor: "pointer",
  font: "inherit",
  fontSize: 14
};

export function TextLink({ children, onClick, style }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{ ...defaultStyle, ...style }}
    >
      {children}
    </button>
  );
}

TextLink.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object
};

TextLink.defaultProps = {
  style: {}
};
